import selection from '@/assets/fonts/icomoon/selection.json'

export default selection.icons.map(({ properties }) => properties.name)
